<script setup lang="ts">
import { TransitionRoot } from '@headlessui/vue'

const props = defineProps({
  show: Boolean,
  hasCloseButton: {
    type: Boolean,
    default: true,
  },
  containerClass: {
    type: String,
    default: 'fixed inset-0',
  },
  contentClass: {
    type: String,
    default: 'max-h-screen',
  },
  showScrollbar: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['close'])
const appStore = useAppStore()

const handleClose = () => {
  emits('close')
}
</script>

<template>
  <TransitionRoot
    :show="props.show"
    enter="transition-opacity"
    enter-from="opacity-0"
    enter-to="opacity-100"
    leave="transition-opacity duration-200"
    leave-from="opacity-100"
    leave-to="opacity-0"
  >
    <div
      :class="[
        'overflow-y-auto bg-brand-info px-4 py-6',
        props.containerClass,
        props.contentClass,
        {
          'no-scrollbar': !props.showScrollbar,
        },
      ]"
    >
      <div class="relative flex items-center justify-center" :class="{'pt-6':appStore.spotHopperEmbedded && !appStore.isTablet}" >
        <slot name="title" />
        <div
          v-if="props.hasCloseButton"
          class="absolute right-0 ml-auto flex size-12 items-center justify-center rounded-full border border-brand-border p-3"
          @click="handleClose"
        >
          <AppiconClose class="size-4" />
        </div>
      </div>
      <!-- panel -->
      <div class="my-6 transform transition-all">
        <slot name="content" />
      </div>
    </div>
  </TransitionRoot>
</template>
